/**
 * Panelin pazarı sunucudan gelene kadar görünen ekran (bkz. `pazarYukle`).
 *
 * Normalde bir an sürüyor: 250 ms sonra beliriyor (`gec-belir`), titreme olmasın.
 */
export function PazarBaglantisi({ ulasilamadi = false }: { ulasilamadi?: boolean }) {
  return (
    <div className="gec-belir flex min-h-screen items-center justify-center bg-bg">
      <div className="space-y-3 px-4 text-center">
        <img
          src="/logo.svg"
          alt=""
          className="mx-auto size-11 rounded-[var(--radius)]"
          aria-hidden="true"
        />
        <div className="mx-auto size-6 animate-spin rounded-full border-2 border-border-strong border-t-accent" />
        <p className="text-sm text-fg-muted">
          {ulasilamadi
            ? 'Sunucuya şu an ulaşılamıyor. Bağlantı kurulunca panel kendiliğinden açılacak.'
            : 'Panele bağlanılıyor…'}
        </p>
      </div>
    </div>
  );
}
